export default __webpack_public_path__ + "static/media/listbuilder-clipboard-selected.02ce5b87.svg";